import React, { useEffect, useRef, useState } from "react";
import { HotTable } from "@handsontable/react";
import "handsontable/dist/handsontable.min.css";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { contextMenu, firstRowRenderer, sumColumnList } from "../../../components/HandsonTable/handsontable";
import { excelRPT215 } from "../../../Report/200/215/RPT215";
import { NullString, ZeroToNull } from "../../../utilities/NullUtil";

export default function P215({ dataTable, dataCol, keyListB, searchData, goPage, submitForm }) {
    const history = useHistory();
    const hot = useRef(null);

    const [editRowList] = useState(["resultDay1Unit", "resultDay2Unit", "resultDay3Unit", "resultDay4Unit", "resultDay5Unit", "resultDay6Unit", "resultDay7Unit", "resultTodayUnit"]);
    const [columnList, setColumnList] = useState([]);
    const [keyColList, setKeyColList] = useState([]);
    const [sumaryBot, setSumaryBot] = useState(0);
    const [updateList, setUpdateList] = useState([]);
    const [readOnlyList, setReadOnlyList] = useState([]);
    const [data, setData] = useState([]);
    const [mergeCells, setMergeCells] = useState([]);

    useEffect(() => {
        //keyListB
        if (dataTable.length > 0 && dataCol.length > 0) {
            HotSetting();
        }
    }, [dataTable, dataCol]);

    useEffect(() => {
        //   console.log('updateList ',updateList);
    }, [updateList]);

    const HotSetting = () => {
        let newHdInfo = [
            {
                itemSeq: "ที่",
                itemDesc: "รายการ",
                itemUnitDesc: "หน่วย",
                itemUnitPrice: "ราคาต่อหน่วย",
                // new
                totalResult: "จำนวนสะสม",
                accrueUnit: "accrueUnit",
                updateKey: "key",
            },
            {
                itemSeq: "",
                itemDesc: "",
                itemUnitDesc: "",
                totalResult: "",
                accrueUnit: "accrueUnit",
                updateKey: "key",
            },
        ];

        // old
        // let newColumnList = ['itemSeq','itemDesc','itemUnitDesc','itemUnitPrice'
        // ,'resultDay1Unit','resultDay2Unit','resultDay3Unit','resultDay4Unit','resultDay5Unit'
        // ,'resultDay6Unit','resultDay7Unit','resultTodayUnit','unitAll','priceAll'
        // ];

        // new
        let newColumnList = [
            "itemSeq",
            "itemDesc",
            "itemUnitDesc",
            "itemUnitPrice",
            "totalResult", // new 12/01/2022
            "resultDay7Unit",
            "resultDay6Unit",
            "resultDay5Unit",
            "resultDay4Unit",
            "resultDay3Unit",
            "resultDay2Unit",
            "resultDay1Unit",
            "resultTodayUnit",
            "unitAll",
            "priceAll",
        ];

        let newMergeCells = [
            { row: 0, col: 0, rowspan: 2, colspan: 1 },
            { row: 0, col: 1, rowspan: 2, colspan: 1 },
            { row: 0, col: 2, rowspan: 2, colspan: 1 },
            { row: 0, col: 3, rowspan: 2, colspan: 1 },
            { row: 0, col: 4, rowspan: 2, colspan: 1 },
            { row: 0, col: 5, rowspan: 2, colspan: 1 },
            { row: 0, col: 6, rowspan: 2, colspan: 1 },
            { row: 0, col: 7, rowspan: 2, colspan: 1 },
            { row: 0, col: 8, rowspan: 2, colspan: 1 },
            { row: 0, col: 9, rowspan: 2, colspan: 1 },
            { row: 0, col: 10, rowspan: 2, colspan: 1 },

            { row: 0, col: 11, rowspan: 2, colspan: 1 }, // new 12/01/2022

            { row: 0, col: 12, rowspan: 2, colspan: 1 }, // new 12/01/2022
            { row: 0, col: 13, rowspan: 1, colspan: 2 }, // new 12/01/2022
        ];
        let newDataTable = [...dataTable];
        let newKeyList = [];
        let SumColList = []; // 4-13
        let sumaryBot = {
            seqPk: "",
            itemDesc: "TOTAL",
            itemUnitDesc: "",
            itemUnitPrice: "",
            totalResult: "", // new 12/01/2022
            contractUnit: "",
            contractAmount: "",
            accrueUnit: "",
            updateKey: "",
        };

        let sumaryRead = [];

        let newReadOnlyList = dataTable.map(() => []);
        newReadOnlyList.push([]);

        dataCol.forEach((obj) => {
            const findIndex = dataTable.findIndex((item) => {
                return item.updateKey === obj.updateKey;
            });

            if (findIndex > -1) {
                let newData = newDataTable[findIndex];

                if (findIndex === 0) {
                    newKeyList.push(obj.resultDay1Date);
                    newKeyList.push(obj.resultDay2Date);
                    newKeyList.push(obj.resultDay3Date);
                    newKeyList.push(obj.resultDay4Date);
                    newKeyList.push(obj.resultDay5Date);
                    newKeyList.push(obj.resultDay6Date);
                    newKeyList.push(obj.resultDay7Date);
                    newKeyList.push(obj.resultDayTodayDate);

                    let newColHd = {
                        ...newHdInfo[0],
                        resultDay1Unit: obj.resultDay1Header,
                        resultDay2Unit: obj.resultDay2Header,
                        resultDay3Unit: obj.resultDay3Header,
                        resultDay4Unit: obj.resultDay4Header,
                        resultDay5Unit: obj.resultDay5Header,
                        resultDay6Unit: obj.resultDay6Header,
                        resultDay7Unit: obj.resultDay7Header,
                        resultTodayUnit: obj.resultTodayHeader,
                        unitAll: "รวมสะสม",
                        priceAll: "",
                    };
                    newHdInfo[0] = newColHd;

                    newColHd = {
                        ...newHdInfo[1],

                        resultDay1Unit: "",
                        resultDay2Unit: "",
                        resultDay3Unit: "",
                        resultDay4Unit: "",
                        resultDay5Unit: "",
                        resultDay6Unit: "",
                        resultDay7Unit: "",
                        resultTodayUnit: "",
                        unitAll: "จำนวน",
                        priceAll: "บาท",
                    };
                    newHdInfo[1] = newColHd;

                    sumaryBot = {
                        ...sumaryBot,
                        resultDay1Unit: "",
                        resultDay2Unit: "",
                        resultDay3Unit: "",
                        resultDay4Unit: "",
                        resultDay5Unit: "",
                        resultDay6Unit: "",
                        resultDay7Unit: "",
                        resultTodayUnit: "",
                        unitAll: "",
                        priceAll: "",
                    };

                    for (let i = 0; i < 8; i++) {
                        sumaryRead.push("N");
                    }
                }

                let unitAll =
                    checkNum(obj.resultDay1Unit) + checkNum(obj.resultDay2Unit) + checkNum(obj.resultDay3Unit) + checkNum(obj.resultDay4Unit) + checkNum(obj.resultDay5Unit) + checkNum(obj.resultDay6Unit) + +checkNum(obj.resultDay7Unit) + checkNum(obj.resultTodayUnit) + checkNum(obj.accrueUnit); //totalResult  new 12/01/2022

                let priceAll =
                    checkNum(obj.resultDay1Unit) * checkNum(newData.itemUnitPrice) +
                    checkNum(obj.resultDay2Unit) * checkNum(newData.itemUnitPrice) +
                    checkNum(obj.resultDay3Unit) * checkNum(newData.itemUnitPrice) +
                    checkNum(obj.resultDay4Unit) * checkNum(newData.itemUnitPrice) +
                    checkNum(obj.resultDay5Unit) * checkNum(newData.itemUnitPrice) +
                    checkNum(obj.resultDay6Unit) * checkNum(newData.itemUnitPrice) +
                    checkNum(obj.resultDay7Unit) * checkNum(newData.itemUnitPrice) +
                    checkNum(obj.resultTodayUnit) * checkNum(newData.itemUnitPrice)+
                    checkNum(obj.accrueUnit) * checkNum(newData.itemUnitPrice);

                newData = {
                    ...newData,
                    itemSeq: newData.seqPk,
                    totalResult: newData.itemUnitPrice === "" ? "" : obj.accrueUnit, //  totalResult new 12/01/2022
                    // itemDesc : ((obj.itemSeq.length === 1)?'':obj.itemSeq+' ') + newData.itemDesc,
                    resultDay1Unit: ZeroToNull(obj.resultDay1Unit),
                    resultDay2Unit: ZeroToNull(obj.resultDay2Unit),
                    resultDay3Unit: ZeroToNull(obj.resultDay3Unit),
                    resultDay4Unit: ZeroToNull(obj.resultDay4Unit),
                    resultDay5Unit: ZeroToNull(obj.resultDay5Unit),
                    resultDay6Unit: ZeroToNull(obj.resultDay6Unit),
                    resultDay7Unit: ZeroToNull(obj.resultDay7Unit),
                    resultTodayUnit: ZeroToNull(obj.resultTodayUnit),
                    unitAll: ZeroToNull(unitAll),
                    priceAll: ZeroToNull(priceAll), // new 23/05/2022
                };

                for (let i = 0; i < 8; i++) {
                    newReadOnlyList[newData.seqPk].push(obj.inputFlag);
                }

                newDataTable[findIndex] = newData;
            }
        });

        //  for (let i = 4; i <= 13; i++) {   // new 12/01/2022
        for (let i = 5; i <= 14; i++) {
            let sum = sumColumnList(newDataTable, newColumnList[i]);

            sumaryBot = {
                ...sumaryBot,
                [`${newColumnList[i]}`]: sum,
            };
        }

        newDataTable.push(sumaryBot);
        newReadOnlyList.push(sumaryRead);
        setSumaryBot(newDataTable.length + 2);

        setData([...newHdInfo, ...newDataTable]);
        setColumnList(newColumnList);
        setMergeCells(newMergeCells);
        setReadOnlyList(newReadOnlyList);
        // newEditRowList.pop()
        // setEditRowList(newEditRowList);
        setKeyColList(newKeyList);
    };

    const checkNum = (val) => {
        if (!val || val === "" || val === null) {
            return 0;
        } else {
            return val;
        }
    };

    const rendercolumns = () => {
        let columnData = [];
        columnList.forEach((item, index) => {
            if (index > 2) {
                columnData.push({
                    data: item,
                    type: "numeric",
                    numericFormat: {
                        pattern: "0,0",
                    },
                });
            } else {
                columnData.push({ data: item });
            }
        });
        return columnData;
    };

    const onAfterChange = (changes, source) => {
        if (!changes) {
            return;
        }

        //changes val
        let row = changes[0][0];
        let col = changes[0][1]; // Check to columnList index
        let oldVal = changes[0][2] === null || changes[0][2] === "" ? 0 : parseInt(changes[0][2]);
        let newVal = changes[0][3] === null || changes[0][3] === "" ? 0 : parseInt(changes[0][3]);
        let indexCol = editRowList.findIndex((item) => item === col);

        if (indexCol > -1) {
            // KeyUpdate from keyListB
            let key = keyListB[row];

            //Get ref From HotTable
            let hotdata = hot.current.hotInstance;

            let indexUnitPrice = columnList.findIndex((item) => item === "itemUnitPrice");

            let itemUnitPrice = hotdata.getDataAtCell(row, indexUnitPrice);

            let newAmountVal = newVal * itemUnitPrice;
            let oldAmountVal = oldVal * itemUnitPrice;

            // //oldVal
            let unitAllIndex = columnList.findIndex((item) => item === "unitAll");

            let unitAll = hotdata.getDataAtCell(row, unitAllIndex);
            let unitAllNew = unitAll - oldVal + newVal;
            hotdata.setDataAtCell(row, unitAllIndex, unitAllNew);

            let priceAll = hotdata.getDataAtCell(row, unitAllIndex + 1);
            let priceAllNew = priceAll - oldAmountVal + newAmountVal;
            hotdata.setDataAtCell(row, unitAllIndex + 1, priceAllNew);

            onUpdateList(col, newVal, key, indexCol);
        }
    };

    const onUpdateList = (col, newVal, key, indexCol) => {
        /** setUpdate Data */

        let newUpdateList = [...updateList];
        if (keyColList[indexCol] && NullString(key) !== "") {
            newUpdateList.push({
                userId: searchData.userId,
                contractNo: searchData.contractNo,
                routeNo: searchData.routeNo,
                resultUnit: newVal,
                resultDate: keyColList[indexCol],
                updateKey: key,
            });

            setUpdateList(newUpdateList);
        }
    };

    const columnSummary = () => {
        if (hot.current && hot.current !== null) {
            let hotTable = hot.current.hotInstance;
            let sumRow = hotTable.countRows() - 1;

            let colSummaryArr = [];
            let countCols = hotTable.countCols();
            if (countCols > 0) {
                // sum would be for column 3 onwards
                for (let i = 2; i < countCols; i++) {
                    colSummaryArr.push({
                        destinationRow: sumRow,
                        destinationColumn: i,
                        // reversedRowCoords: true,
                        type: "sum",
                        ranges: [[2, sumRow - 1]],
                    });
                }
                return colSummaryArr;
            } else {
                return [];
            }
        } else {
            return [];
        }
    };

    const cells = (row, col) => {
        const cellProperties = {};

        /**
         * Set Coloer Table
         */
        if (row === 0 || row === 1) {
            cellProperties.renderer = firstRowRenderer; //Header Table
        }

        if (row > 1) {
            cellProperties.className = " detail";
        }

        cellProperties.readOnly = true;
        // }
        // row -newReadOnlyList 1 == 2 row hot
        // col -newReadOnlyList 0 == 4 col hot

        //  if(row > 1 && (col > 3 && col <=11 )){   // new 12/01/2022
        if (row > 1 && col > 3 && col <= 12) {
            // new 12/01/2022
            // if(readOnlyList && readOnlyList.length > 0 && row-1 >=0 && col-4 >=0 ){
            //     if(readOnlyList[row-1][col-4]  && readOnlyList[row-1][col-4] === 'Y'){
            //         cellProperties.readOnly = false;
            //         cellProperties.className = ' detail_input'
            //     }
            // }
            if (readOnlyList && readOnlyList.length > 0 && row - 1 >= 0 && col - 5 >= 0) {
                if (readOnlyList[row - 1][col - 5] && readOnlyList[row - 1][col - 5] === "Y") {
                    cellProperties.readOnly = false;
                    cellProperties.className = " detail_input";
                }
            }
        }

        if (row === sumaryBot - 1) {
            cellProperties.readOnly = true;
            cellProperties.className = " summary_bot";
        }

        return cellProperties;
    };

    const onExport = () => {
        excelRPT215(data); //, setLoading, toast
    };

    return (
        <div>
            {dataTable && dataTable.length > 0 ? (
                <>
                    {data.length > 0 ? (
                        <HotTable
                            ref={hot}
                            data={data}
                            columns={rendercolumns()}
                            mergeCells={mergeCells}
                            autoRowSize={false}
                            autoColumnSize={true}
                            colWidths={[50, 400, null, null, null, 100, 100, 100, 100, 100, 100, 100, 100, 50, 100]} //new 23/05/2022
                            height={data.length > 50 ? "500px" : "280px"}
                            contextMenu={contextMenu}
                            cells={(row, col) => cells(row, col)}
                            columnSummary={columnSummary}
                            afterChange={(changes, source) => onAfterChange(changes, source)}
                            // afterRender
                        ></HotTable>
                    ) : (
                        "Load Data .."
                    )}
                </>
            ) : (
                "No Data"
            )}
            <div className="p-col-12 p-md-12">
                <div className="p-grid" style={{ textAlign: "center", marginTop: 20 }}>
                    <div className="p-col-12">
                        <Button className="p-button-success p-button btn-srh-responsive" icon="pi pi-save" label="บันทึก" disabled={!(dataTable && dataTable.length > 0)} style={{ width: 120, marginLeft: "5px", marginTop: "10px" }} onClick={() => submitForm(updateList, 215)} />
                        <Button className="p-button-secondary p-button btn-long-responsive" icon="pi pi-arrow-left" label="กลับหน้าจอแสดงรายการ" disabled={!(dataTable && dataTable.length > 0)} style={{ width: 250, marginLeft: "5px", marginTop: "10px" }} onClick={() => history.push("/208")} />
                        <Button className="p-button-excel p-button btn-long-responsive" icon="fa fa-file-excel" label="Export Excel" disabled={!(dataTable && dataTable.length > 0)} style={{ width: 250, marginLeft: "5px", marginTop: "10px" }} onClick={() => onExport()} />
                    </div>
                </div>
            </div>
        </div>
    );
}
